<template>
  <v-card height="100%" max-width="200%" width="100%" >
    <v-tabs background-color="#dceed1" color="deep-purple accent-4">
      <v-tab v-for="tab in panelTabs" :key="tab.id" >
       {{tab.title}}
      </v-tab>
      <v-spacer></v-spacer>
      <v-tab class="d-flex" style="" disabled><Clock /></v-tab>
      <v-tab-item>
        <div class="chip-categories">
          <v-slide-group  show-arrows center-active mandatory>
            <v-slide-item v-slot:default="{ active, toggle }" v-on:change="filterItemsShown('favorites')">
              <v-btn
                class="mx-2"
                :input-value="active"
                active-class="purple white--text"
                depressed
                rounded
                @click="toggle"
              >
                <v-icon left>mdi-pin</v-icon>
                Favoritos
              </v-btn>
            </v-slide-item>

            <v-slide-item v-slot:default="{ active, toggle }" v-on:change="filterItemsShown('recent')">
              <v-btn
                class="mx-2"
                :input-value="active"
                active-class="purple white--text"
                depressed
                rounded
                @click="toggle"
              >
                <v-icon left>mdi-alarm-check</v-icon>
                Recientes
              </v-btn>
            </v-slide-item>
            
            <v-slide-item
              v-for="categoria in categoriesWithItems"
              :key="categoria.id"
              v-slot:default="{ active, toggle }"
              v-on:change="filterItemsShown(categoria.id)"
            >
              <v-btn
                class="mx-2"
                :input-value="active"
                active-class="purple white--text"
                depressed
                rounded
                @click="toggle"
              >
              <!-- <v-icon left>mdi-alarm-check</v-icon> -->
                {{ categoria.categoria }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </div>
        <div class="btn-container" >
          <template v-if="getFilteredServices">
            <div
              v-for="servicio in getFilteredServices"
              v-bind:key="servicio.codigo"
               @click="addItem(servicio)"
            > 
              <ItemVenta 
                :idCategoria="servicio.id_categoria"
                :itemID="servicio.id"
                :codigo="servicio.codigo"
                :itemCategoria="servicio.categoria"
                :itemName="servicio.descripcion"
                :imageUrl="servicio.imagen"
              />            
            </div>          
          </template>
          <template v-if="getFilteredProducts">
            <div
              v-for="producto in getFilteredProducts"
              v-bind:key="producto.codigo"
              @click="addItem(producto)"
            > 
              <ItemVenta 
                :idCategoria="producto.id_categoria"
                :itemID="producto.id"
                :codigo="producto.codigo"
                :itemCategoria="producto.categoria"
                :itemName="producto.descripcion"
                :imageUrl="producto.imagen"
              />            
            </div>          
          </template>
        </div>
      </v-tab-item>
      <!-- The tab for the services table -->
      <v-tab-item>
        <div class="tbl-services">
          <v-data-table
            color="primary"
            :headers="servicesTblHeaders"
            :items="allServices"
            class="elevation-1"
            :search="serviceSearch"
            :expanded.sync="expandedServDetails"
            :single-expand="singleExpand"
            show-expand
          >
            <template v-slot:top>
              <v-text-field v-model="serviceSearch" append-icon="mdi-magnify"  hide-details label="Buscar servicio" class="mx-4"></v-text-field>
              <v-spacer></v-spacer>
            </template>
            <template v-slot:item.precio_venta="{item}">
              <v-chip color="darkgrey" dark>${{item.precio_venta}}</v-chip>
            </template>
            <template v-slot:item.id="{item}">
              <v-btn 
                elevation="4"
                icon
                dark
                color="accent"
                @click="addItem(item)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.favorited="{ item }">
              <FavoritedBtn @toggledFavorite="reloadFavorites" v-model="item.favorited" :id="item.id" itemType="service"/>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td style="text-align: center;" :colspan="headers.length">{{item.detalle}}</td>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="tbl-products">
          <v-data-table
            color="primary"
            :headers="productsTblHeaders"
            :items="allProducts"
            class="elevation-1"
            :search="productSearch"
            :expanded.sync="expandedProdDetails"
            :single-expand="singleExpand"
            show-expand
          > 
            <template v-slot:top>
              <v-text-field 
                v-model="productSearch" 
                append-icon="mdi-magnify"  
                hide-details 
                label="Buscar producto" 
                class="mx-4"
              ></v-text-field>
              <v-spacer></v-spacer>
            </template>
            <template v-slot:item.precio_venta="{item}">
              <v-chip color="darkgrey" dark>${{item.precio_venta}}</v-chip>
            </template>
            <template v-slot:item.id="{item}">
              <v-btn 
                elevation="4"
                icon
                color="accent"
                @click="addItem(item)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.favorited="{ item }">
              <FavoritedBtn @toggledFavorite="reloadFavorites" v-model="item.favorited" :id="item.id" itemType="product" />
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td style="text-align: center;" :colspan="headers.length">{{item.detalle}}</td>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>
    <!-- The tab for the services table -->  
    </v-tabs>
  </v-card>
</template>

<script>
// import { GET_CATEGORIES } from '../queries';
import { mapActions, mapGetters } from 'vuex';
import * as IDBService from '../../services/IDBService';
// const {getCategoriasAll} = window.api.services.categoriasService;  
// const {getServiciosAll} = window.api.services.serviciosService;
// const {getProductosAll} = window.api.services.productosService;
import ItemVenta from './ItemVenta';
import FavoritedBtn from "../FavoritedBtn";
import Clock from '../Clock';

export default {
  name: 'ItemsBillPanel',
  components: {
    ItemVenta,
    FavoritedBtn,
    Clock
  },
  data() {
    return {
      expandedServDetails: [],
      expandedProdDetails: [],
      singleExpand: true,
      services: [],
      serviceSearch: "",
      products: [],
      recentItems: [],
      productSearch: "",
      tabIndex: 0,
      filterItems: {filter: false, filterID: 'none'},
      defaultItemImg: '../assets/img/servicios/default/anonymous.jpg',
      panelTabs:[
        {
          id: 1,
          title: "Botones",
          content: "botones",
          data: ["One", "Two", "three", "Four", "Five", "Six"],
        },
        {
          id: 2,
          title: "Servicios",
          content: "servicios",
          data:  "Two",
        },
        {
          id: 3,
          title: "Productos",
          content: "productos",
          data: "Three",
        },
      ],
      tabData: [],
      productsTblHeaders:[
        {
          text: 'Codigo',
          align: 'left',
          sortable: true,
          value: 'codigo'
        },
        {
          text: 'Descripcion',
          align: 'left',
          sortable: true,
          value: 'descripcion'
        },
        {
          text: 'Categoria',
          align: 'left',
          sortable: true,
          value: 'categoria'
        },
        {
          text: 'Stock',
          align: 'left',
          sortable: true,
          value: 'stock'
        },
        {
          text: 'Precio',
          align: 'left',
          sortable: true,
          value: 'precio_venta'
        },
        { text: 'Más', value: 'data-table-expand' },
        {
          text: 'Favorito',
          align: 'left',
          sortable: false,
          value: 'favorited'
        },
        {
          text: "Agregar",
          align: 'center',
          sortable: false,
          value: 'id'
        }
      ],
      servicesTblHeaders: [
        {
          text: 'Codigo',
          align: 'left',
          sortable: true,
          value: 'codigo'
        },
        {
          text: 'Descripcion',
          align: 'left',
          sortable: true,
          value: 'descripcion'
        },
        {
          text: 'Categoria',
          align: 'left',
          sortable: true,
          value: 'categoria'
        },
        {
          text: 'Precio',
          align: 'left',
          sortable: true,
          value: 'precio_venta'
        },
        { text: 'Más', value: 'data-table-expand' },
        {
          text: 'Favorito',
          align: 'left',
          sortable: false,
          value: 'favorited'
        },
        {
          text: "Agregar",
          align: 'center',
          sortable: false,
          value: 'id'
        }
      ],
    }
  },

  methods: {
    ...mapActions([
      'addBillItem',
      'fetchCategorias', 
      'fetchServicesAll', 
      'fetchProductsAll',
      'fetchServicesByCategory',
      'setPromos'
    ]),
    getCategoriasAll(){ return this.demoCategorias; },
    getServiciosAll(){
      return this.demoServicios;
    },
    getProductosAll(){ return this.demoProductos; },
    addItem(item){
      const itemPayload = this.makeBillItemPayload(item);
      this.addBillItem(itemPayload);
      this.saveRecentItem(item);
    },
    makeBillItemPayload(item){
      const currentItem = {...item};//Object.assign({},item);
      const itemCategoria = this.categories.filter(category => category.id == currentItem.id_categoria);
      const cliente = this.billClientData;
      const statusCliente = cliente && cliente.status ? cliente.status.toLowerCase():'turista';
      const itemPromo = this.promos.find(promo =>{ 
        const {beneficiarios} = promo; 
        const clientStatusMatch = beneficiarios.includes(statusCliente);
        const codesMatch = promo.codigo_item == currentItem.codigo;
        return codesMatch  && clientStatusMatch;
      });
      if(itemPromo) {
        const precioPromo = itemPromo.precio_promo;
        const itemPrice =Number(currentItem.precio_venta);
        console.log(precioPromo, itemPrice);
        switch (itemPromo.tipo_promo) {
          case "precio":
            currentItem.precio_venta = precioPromo;
            break;
          case "porcentaje":
            // const porcentaje = itemPromo.porcentaje_promo;
            currentItem.precio_venta = itemPrice - (itemPrice*(itemPromo.porcentaje_promo)/100);
            break;
        }
      }
      const newPayload = {
        ...currentItem, 
        minimo: itemCategoria[0].minimo,
        idCategoria : itemCategoria[0].id
      };
      return newPayload;
    },
    reloadFavorites(){
      const servicios = this.getServiciosAll();
      this.fetchServicesAll(servicios);
      const productos = this.getProductosAll();
      this.fetchProductsAll(productos);
      this.filterItemsShown('favorites');
    },
    saveRecentItem(item){
      console.log(item);
      IDBService.getRecentlyUsedBillItem(item.id)
      .then( result =>{
        console.log(result);
        IDBService.updateRecentlyUsedBI(item.id);
        this.fetchRecentlyUsed();
      })
      .catch( error => {
        console.log(error);
        IDBService.addRecentlyUsedBillItem(item);
        this.fetchRecentlyUsed();
      });
    },
    fetchRecentlyUsed(){
      IDBService.getRecentlyUsedBillItems().then((result)=>{        
        const recent = result;
        this.recentlyUsedItems = recent;
        this.cleanRecentlyUsed(recent);
      }).catch(error=>console.error("[getRecentlyUsedBillItems|error] ", error))
      .finally(()=>{
        console.log("[Finally block | IDBService.getRecentlyUsedBillItems()]");
      });
      
    },
    cleanRecentlyUsed(recent){
      const services = [...this.allServices];
      const products = [...this.allProducts];
      setTimeout(()=>{
        for(let i=0; i<recent.length;i++){
          const item = recent[i];
          const serviceFound = services.find(service => service.id == item.id && service.codigo == item.codigo );
          const productFound = products.find(product => product.id == item.id && product.codigo == item.codigo );
          const exists = serviceFound || productFound;
          if(!exists) IDBService.deleteRecentlyUsedByID(item.id);
        }
      },500);
    },
    getImgURL(){      
      //TODO: figure out how to solve this
      return "../assets/img/servicios/default.png";
    },
    tabClass(idx){
      if (this.tabIndex === idx) {
        return ['tab']
      } 
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    filterItemsShown(filterBy) {     
      //If the new filter is a number and there is no filter is yet applyed or the previous filter is not the same as this one
      if( typeof filterBy == 'number' && this.categories){
        this.categories.forEach(category => {
          if ( category.id === filterBy && category.tipo === 'servicios' ) {
            this.getFilteredProducts = [];
            this.getFilteredServices = this.servicesByCategory(category.id);
          }
          else if ( category.id === filterBy && category.tipo === 'productos' ) {
            this.getFilteredServices = [];
            this.getFilteredProducts = this.productsByCategory(category.id);
          }
        });         
      }
      else if( typeof filterBy == 'string' && this.categories ){
        if(filterBy === 'favorites'){
          const favoriteItems=[];
          this.getFilteredServices = this.getFilteredProducts = [];
          this.categories.forEach(category => {
            if( category.tipo === 'servicios' ){
              this.allServices.forEach(service => {
                if(service.id_categoria === category.id && (service.favorited === 1 | service.favorited === 'Y'))
                  favoriteItems.push(service);
              });
            }
            else if( category.tipo === 'productos'){
              this.allProducts.forEach(product =>{
                if(product.id_categoria === category.id && (product.favorited === 1 | product.favorited === 'Y'))
                  favoriteItems.push(product);
              });
            }
          });
          this.getFilteredServices =  favoriteItems.slice(0,30);
        }
        // else if(filterBy === 'all'){ this.getFilteredServices = this.allServices }
        else if(filterBy === 'recent') {
          this.getFilteredProducts = [];
          this.getFilteredServices =  this.recentlyUsedItems; 
        }
      }
      // else{ console.log("this.categories is not ready"); }
    },
  },
  computed: {
    ...mapGetters([
      'categories', 
      'servicesByCategory', 
      'productsByCategory', 
      'allServices', 
      'allProducts',
      'promos',
      'billClientData',
      'demoServicios',
      'demoProductos',
      'demoCategorias',
      'demoPromos'
    ]),
    getFilteredServices: {
      get: function(){
        return this.services;
      },
      set: function(fServices){
        this.services = fServices;
        return this.services;
      }
    },
    getFilteredProducts:{
      get: function() {
        return this.products;
      },
      set: function(fProducts){     
        this.products = fProducts;
        return this.products;
      }
    },
    recentlyUsedItems: {
      get: function() {
        return [...this.recentItems.slice(0,30)];
      },
      set: function(payload){
        this.recentItems = payload;
      }
    },
    categoriesWithItems(){
      const categories = this.categories.filter(category=>{
        let hasItems = false;
        switch (category.tipo) {
          case "servicios":
            // const foundService = this.allServices.find(service => (service.id_categoria == category.id));
            hasItems = (this.allServices.find(service => (service.id_categoria == category.id))) ? true:hasItems;
            break;
          case "productos":
            // const foundProduct = this.allProducts.find(product => (product.id_categoria == category.id));
            hasItems = (this.allProducts.find(product => (product.id_categoria == category.id))) ? true:hasItems;
            break;
          default:
            break;
        }
        if (hasItems) return category;
      });
      return categories;
    }
  },
  watch: {
    categories: function(){
      this.filterItemsShown('favorites');
    }
  },
  mounted(){
    const categorias = this.getCategoriasAll();
    this.fetchCategorias(categorias);
    const servicios = this.getServiciosAll();
    this.fetchServicesAll(servicios);
    const productos = this.getProductosAll();
    this.fetchProductsAll(productos);
    this.fetchRecentlyUsed();
    this.filterItemsShown('favorites');
    const promos = [...this.demoPromos];
    console.log("[promos] ", promos);
    this.setPromos(promos);
  }
}
</script>


<style>
.item-btns{
  background-color: #69a297;
  height: 100%;
}
.chip-categories{
  padding: 0.5rem;
}
/*Botones Principales*/
.btn-container{
  display: flex;
  flex-wrap: wrap;
  margin-left: 5px;
  margin-top: .4rem;
  /* height: 75vh;
  background-color: rgb(94, 94, 94); */
}
</style>
